import { useForm as useHookForm } from 'react-hook-form';

const useForm = () => {
  const formInfo = useHookForm({});

  return { ...formInfo };
};

export default useForm;
